import { createHash } from "utils/helperFunctions";
import { db } from "config/firebase";
import { doc, setDoc } from "firebase/firestore";

const setNotification = async (data: any): Promise<void> => {
  await setDoc(doc(db, "notifications", data.id), data);
};

const sendJoinGameNotification = async (
  user: any,
  gameData: any,
): Promise<void> => {
  const id = createHash(`${user.uid + gameData.hostId}pending`);
  await setDoc(doc(db, "notifications", id), {
    id,
    senderId: user.uid,
    receiverId: gameData.hostId,
    msg: `${user.displayName} has sent a request to join ${gameData.gameName}`,
    status: "pending",
    timeStamp: Date.now(),
  });
};

const sendAcceptNotification = async (
  playerId: string,
  hostId: string,
  gameName: string,
  gameId: string,
): Promise<void> => {
  const noteId = createHash(`${playerId + gameId}waitlist`);
  const msg = {
    id: noteId,
    senderId: hostId,
    receiverId: playerId,
    msg: `Your request to join ${gameName} has been accepted`,
    timeStamp: Date.now(),
    status: "waitlist",
  };
  await setDoc(doc(db, "notifications", noteId), msg);
};

const sendDeclineNotification = async (reqData: any): Promise<void> => {
  const { senderId, receiverId, gameName, gameId } = reqData;
  const noteId = createHash(`${senderId + gameId}declined`);
  const msg = {
    id: noteId,
    senderId: receiverId,
    receiverId: senderId,
    msg: `Your request to join ${gameName} has been declined`,
    timeStamp: Date.now(),
    status: "declined",
  };
  await setDoc(doc(db, "notifications", noteId), msg);
};

const sendPlayerDeclinedNotification = async (reqData: any): Promise<void> => {
  const { senderId, receiverId, gameName, gameId } = reqData;
  const noteId = createHash(`${senderId + gameId}playerDeclined`);
  const msg = {
    id: noteId,
    senderId: receiverId,
    receiverId: senderId,
    msg: `${reqData.senderName} has declined their seat at ${gameName}`,
    timeStamp: Date.now(),
    status: "playerDeclined",
  };
  await setDoc(doc(db, "notifications", noteId), msg);
};

const sendConfirmationPendingNotification = async (
  reqData: any,
): Promise<void> => {
  const noteId = createHash(
    `${reqData.senderId + reqData.gameId}confirmationPending`,
  );
  const msg = {
    id: noteId,
    senderId: reqData.receiverId,
    receiverId: reqData.senderId,
    msg: `You are next for game ${reqData.gameName}. Please confirm or decline now`,
    timeStamp: Date.now(),
    status: "confirmationPending",
  };

  await setDoc(doc(db, "notifications", noteId), msg);
};

const sendHostConfirmedNotification = async (
  playerId: string,
  hostId: string,
  gameName: string,
): Promise<void> => {
  const noteId = createHash(`${playerId + gameName}hostConfirmed`);
  const msg = {
    id: noteId,
    senderId: hostId,
    receiverId: playerId,
    msg: `Your seat at ${gameName} has been confirmed. Please go to the table now`,
    timeStamp: Date.now(),
    status: "hostConfirmed",
  };
  await setDoc(doc(db, "notifications", noteId), msg);
};

const sendPlayerConfirmedNotification = async (reqData: any): Promise<void> => {
  const noteId = createHash(
    `${reqData.senderName + reqData.gameId}playerConfirmed`,
  );
  const msg = {
    id: noteId,
    senderId: reqData.receiverId,
    receiverId: reqData.senderId,
    msg: `${reqData.senderName} has accepted their seat at ${reqData.gameName} and should be on the way soon`,
    timeStamp: Date.now(),
    status: "playerConfirmed",
  };
  await setDoc(doc(db, "notifications", noteId), msg);
};

export default {
  setNotification,
  sendJoinGameNotification,
  sendAcceptNotification,
  sendDeclineNotification,
  sendConfirmationPendingNotification,
  sendPlayerDeclinedNotification,
  sendHostConfirmedNotification,
  sendPlayerConfirmedNotification,
};
